<template>
  <fragment>
    <div class="grid-bg">
      <div class="container">
        <h1 class="header-level-2 mti_font_element">
          {{$t('trading-platform.header')}}
        </h1>
      </div>
    </div>

    <div class="resources-landing-banner resources-banner">
      <div class="container">
        <div class="resources-landing-banner--heading">
          <h2 v-html="$t('trading-platform.intro')" />
        </div>
        <div class="illustrations">
          <div class="cloud-white-big subtleHorizontalMovement download-banner-animated">
          </div>
          <div class="cloud-white-md subtleHorizontalMovement2 download-banner-animated">
          </div>
          <div class="img arm-mobile">
          </div>
          <div class="img arm-tablet">
          </div>
          <div class="img arm-notebook">
          </div>
          <div class="img arm-phablet">
          </div>
          <img src="@/assets/images/download-banner-sprite-sheet.png">
        </div>
      </div>
    </div>

    <div class="resources-landing bright resources-landing--trading-platforms">
      <div class="container">
        <div class="trading-platforms">
          <div class="trading-platforms-items">
            <div class="trading-platforms-item desktop">
              <!--  <div class="trading-platforms-item--image-block">
                <span><img
                    src="@/assets/images/trading-platforms/icon-desktop.svg"></span>
              </div>-->
              <div class="trading-platforms-item--content">
                <h3 class="trading-platforms-item--content--title">
                  {{$t('trading-platform.tab-app.desktop-web.name')}}
                </h3>
                <p class="trading-platforms-item--content--description">{{$t('trading-platform.tab-app.desktop-web.desc')}}</p>
                <ul class="trading-platforms-item--content--list">
                  {{$t('trading-platform.tab-app.hl-title')}}:
                  <li v-for="line in $t('trading-platform.tab-app.desktop-web.highlights').split('\n')" :key="line">{{line}}</li>
                </ul>
              </div>
              <div class="trading-platforms-item--footer">
                <a class="trading-platforms-item--footer-link" href="https://bi-winning.org/trading">{{$t('trading-platform.tab-app.desktop-web.link')}}</a>
              </div>
            </div>
          

          

            <!-- 
              <div class="trading-platforms-item col-sm-4 webapp">
              <div class="trading-platforms-item--image-block">
                <span><img
                    src="@/assets/images/trading-platforms/icon-ios.svg"></span><span><img
                    src="@/assets/images/trading-platforms/icon-android.svg"></span>
              </div>
              <div class="trading-platforms-item--content">
                <h3 class="trading-platforms-item--content--title">
                  {{$t('trading-platform.tab-app.mobile-web.name')}}
                </h3>
                <p class="trading-platforms-item--content--description">
                  {{$t('trading-platform.tab-app.mobile-web.desc')}}
                </p>
                <ul class="trading-platforms-item--content--list">
                   {{$t('trading-platform.tab-app.hl-title')}}:
                   <li v-for="line in $t('trading-platform.tab-app.mobile-web.highlights').split('\n')" :key="line">{{line}}</li>
                </ul>
              </div>
              <div class="trading-platforms-item--footer">
                <a class="trading-platforms-item--footer-link" href="#">{{$t('trading-platform.tab-app.mobile-web.link')}}</a>
              </div>
            </div>
            
              <div class="trading-platforms-item col-sm-4 android">
              <div class="trading-platforms-item--image-block">
                <span><img
                    src="@/assets/images/trading-platforms/icon-android.svg"></span>
              </div>
              <div class="trading-platforms-item--content">
                <h3 class="trading-platforms-item--content--title">
                  {{$t('trading-platform.tab-app.android-native.name')}}
                </h3>
                <p class="trading-platforms-item--content--description">
                  {{$t('trading-platform.tab-app.android-native.desc')}}
                </p>
                <ul class="trading-platforms-item--content--list">
                  {{$t('trading-platform.tab-app.hl-title')}}:
                  <li v-for="line in $t('trading-platform.tab-app.android-native.highlights').split('\n')" :key="line">{{line}}</li>
                </ul>
              </div>
              <div class="trading-platforms-item--footer">
                <a class="trading-platforms-item--footer-link" href="#">{{$t('trading-platform.tab-app.android-native.link')}}</a>
              </div>
            </div>
             -->

          </div>
        </div>
      </div>
    </div>

  </fragment>
</template>
<script>
import "../../assets/css/trading-platform.css"
export default {
}
</script>